/**
 * @file DesktopDropdownMenu barrel.
 * @description Public entry point for the shared desktop dropdown-menu
 * primitive (SE-5087) and its types.
 * @module components/molecules/DesktopDropdownMenu
 */
export { default } from "./DesktopDropdownMenuContainer";
export { default as DesktopDropdownMenuContainer } from "./DesktopDropdownMenuContainer";
export type {
  DesktopDropdownMenuItem,
  DesktopDropdownMenuPlacement,
  DesktopDropdownMenuProps,
} from "./DesktopDropdownMenuView";
